import { FacebookIcon, InstagramIcon, TelegramIcon, ViberIcon } from 'shared/assets/icons'

type SocialPlatform = 'facebook' | 'instagram' | 'telegram' | 'viber'

export const getSocialUrl = (url: string, platform: SocialPlatform): string | null => {
  if (!url) return null

  const isFullUrl = url.startsWith('http') || url.startsWith('viber://')
  if (isFullUrl) return url

  switch (platform) {
    case 'facebook':
      return `https://facebook.com/${url}`
    case 'instagram':
      return `https://instagram.com/${url}`
    case 'telegram':
      return `https://t.me/${url}`
    case 'viber':
      return `viber://chat?number=%2B${url}`
    default:
      return url
  }
}

export const getSocialUrls = (storeInfo: {
  facebook_url?: string
  instagram_url?: string
  telegram_url?: string
  viber_url?: string
}) => {
  return [
    { Icon: FacebookIcon, Name: 'Facebook', url: getSocialUrl(storeInfo.facebook_url ?? '', 'facebook') },
    { Icon: InstagramIcon, Name: 'Instagram', url: getSocialUrl(storeInfo.instagram_url ?? '', 'instagram') },
    { Icon: TelegramIcon, Name: 'Telegram', url: getSocialUrl(storeInfo.telegram_url ?? '', 'telegram') },
    { Icon: ViberIcon, Name: 'Viber', url: getSocialUrl(storeInfo.viber_url ?? '', 'viber') },
  ].filter(item => item.url !== null)
}
